import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-912da282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-6xl mx-auto p-6 bg-slate-800 rounded-xl shadow-lg border border-slate-700" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-2xl font-bold mb-6 text-slate-100 flex items-center gap-2\" data-v-912da282><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"text-primary-500\" data-v-912da282><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-912da282></path><polyline points=\"14 2 14 8 20 8\" data-v-912da282></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-912da282></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-912da282></line><polyline points=\"10 9 9 9 8 9\" data-v-912da282></polyline></svg> JSON Formatter </h2>", 1)
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 justify-center sm:justify-start" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_6 = {
  key: 0,
  class: "json-output p-4 bg-slate-950 rounded-lg border border-slate-700 text-slate-300 font-mono text-sm overflow-x-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "p-4 bg-slate-950 rounded-lg border border-slate-700 text-slate-300 font-mono text-sm overflow-x-auto max-h-[600px]"
}
const _hoisted_8 = {
  key: 0,
  class: "fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/90 p-4"
}
const _hoisted_9 = { class: "relative w-full max-w-7xl h-[90vh] bg-slate-800 rounded-xl shadow-2xl flex flex-col border border-slate-700" }
const _hoisted_10 = { class: "flex items-center justify-between p-4 border-b border-slate-700" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-slate-100" }, "JSON Tree View", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex-1 overflow-auto p-4 bg-slate-950" }
const _hoisted_15 = {
  key: 0,
  class: "fixed bottom-8 left-1/2 -translate-x-1/2 bg-slate-900 text-white px-6 py-3 rounded-full shadow-xl border border-slate-700 flex items-center gap-2 z-[60]"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "text-green-400"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_json_tree_view = _resolveComponent("json-tree-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        class: "w-full h-48 px-4 py-3 bg-slate-900 border border-slate-700 rounded-lg text-slate-300 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/50 resize-y",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jsonInput) = $event)),
        placeholder: "Paste your JSON here... e.g. {\"key\": \"value\"}"
      }, "\n        ", 512), [
        [_vModelText, _ctx.jsonInput]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "px-4 py-2 bg-primary-600 hover:bg-primary-500 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formatJSON && _ctx.formatJSON(...args)))
        }, " Format "),
        (_ctx.formattedJson)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleView && _ctx.toggleView(...args)))
            }, _toDisplayString(_ctx.isTreeView ? 'Show Text' : 'Show Tree'), 1))
          : _createCommentVNode("", true),
        (_ctx.isTreeView && _ctx.formattedJson)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = true))
            }, " Fullscreen Tree "))
          : _createCommentVNode("", true),
        (_ctx.formattedJson)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2 ml-auto",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyToClipboard(_ctx.isTreeView ? JSON.stringify(_ctx.parsedJson, null, 2) : _ctx.formattedJson)))
            }, " Copy "))
          : _createCommentVNode("", true)
      ]),
      (_ctx.formattedJson)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.isTreeView)
              ? (_openBlock(), _createElementBlock("pre", _hoisted_6, _toDisplayString(_ctx.formattedJson), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_json_tree_view, { data: _ctx.parsedJson }, null, 8, ["data"])
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("button", {
                class: "text-slate-400 hover:text-white",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal = false))
              }, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_json_tree_view, { data: _ctx.parsedJson }, null, 8, ["data"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "transform translate-y-4 opacity-0",
      "enter-to-class": "transform translate-y-0 opacity-100",
      "leave-active-class": "transition ease-in duration-200",
      "leave-from-class": "transform translate-y-0 opacity-100",
      "leave-to-class": "transform translate-y-4 opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.showSnackbar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" Copied to clipboard! ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}